import styled from 'styled-components';

const stylingVariables = {
    main_color: '#00a5ad',
    secondary_color: '#993B8B',
    tertiary_color: '#455BA4',
};

type ColorScheme = 'teal' | 'pink' | 'purple';

interface Props {
    colorScheme: ColorScheme;
}

const getColor = (colorScheme: ColorScheme) => {
    switch (colorScheme) {
        case 'teal':
            return stylingVariables.main_color;
        case 'pink':
            return stylingVariables.secondary_color;
        case 'purple':
            return stylingVariables.tertiary_color;
    }
};

export const SectionWrap = styled('div')`
    background-color: #ffffff;
`;

export const TitleWrap = styled('div')<Props>`
    margin: 1em 0;
    border-bottom: 2px solid ${(props) => getColor(props.colorScheme)};

    h2 {
        color: ${(props) => getColor(props.colorScheme)};
        font-size: 20px;
        margin: 5px 0 12px 0;
    }
`;

export const SummarySectionContent = styled('div')`
    margin: 1em 0;
`;
